import { Button } from "../../components/ui/Button";
import { CopyField } from "../../components/ui/CopyField";
import { Panel } from "../../components/ui/feedback";
import { useI18n } from "../../i18n/I18nProvider";

export interface InviteRevealProps {
  link: string;
  onDone: () => void;
}

/** The invitation link, shown once. It is never listed again after this panel closes. */
export function InviteReveal({ link, onDone }: InviteRevealProps) {
  const { t } = useI18n();
  return (
    <Panel className="space-y-3">
      <p className="text-note font-semibold text-red">{t("members.inviteOnce")}</p>
      <CopyField value={link} />
      <div className="flex justify-end">
        <Button variant="ghost" onClick={onDone}>
          {t("common.close")}
        </Button>
      </div>
    </Panel>
  );
}
